import api_base, { serializeParams } from '@/api/base';
import { ClientsTableParams } from '@/views/clients';
import { Client, clientSchema } from '@/views/clients/data/schema';

interface ClientList {
  next: number | null
  previous: number | null
  results: Client[],
  count: number
}

export const get_clients = async (params: ClientsTableParams | null = null): Promise<ClientList> => {
  const response = await api_base.get(
    '/api/v1/client/list',
    {
      params: { ...params },
      paramsSerializer: params => serializeParams(params)
    }
  )
  return response.data;
};

interface AddClient {
  name: string
  client_type?: string
  [key: string]: any // allow other fields
}

export const add_client = async (body: AddClient): Promise<void> => {
  await api_base.post(
    '/api/v1/client/create',
    body,
  );
};

export const update_client = async (id: string, body: AddClient): Promise<Client> => {
  const response = await api_base.patch(
    '/api/v1/client/update/' + id,
    body,
  );
  const parsedResponse = clientSchema.parse(response.data);
  return parsedResponse;
};

export const remove_client = async (id: string): Promise<void> => {
  await api_base.delete(
    '/api/v1/client/remove/' + id
  )
}

interface UniqueName {
  taken: boolean
}

export const check_name_unique = async (name: string): Promise<boolean> => {
  try {
    const response = await api_base.get(
      '/api/v1/client/name/taken/' + name
    )
    const resp: UniqueName = response.data
    return !resp.taken;
  } catch (_) {
    return true;
  }
}

export interface PartyCase {
  id: number;
  name: string;
  year?: number | null;
  number?: string | null;
  type_name?: string | null;
  location_name?: string | null;
  assigned_to_name?: string | null;
  visibility?: string | null;
  created_at?: string | null;
}

export interface Party extends Client {
  total_cases_as_client: number;
  total_cases_as_adversary: number;
  cases_as_client: PartyCase[];
  cases_as_adversary: PartyCase[];
}

export const get_party = async (id: string): Promise<Party> => {
  const response = await api_base.get(`/api/v1/party/${id}`);
  return response.data;
};